import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-selectInput-control-value-view, [app-selectInput-control-value-view]',
  templateUrl: './selectInput-control-value-view.component.html',
  styleUrls: ['./selectInput-control-value-view.component.scss']
})
export class SelectInputControlValueViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
